import * as css from 'css/exports.module.scss';

import './RecordRow.scss';

import { Row } from 'antd';
import { When } from 'react-if';

import React, { PropsWithChildren } from 'react';

export interface SonarRecordRowProps {
	condition?: boolean;
}

export const SonarRecordRow: React.FC<PropsWithChildren<SonarRecordRowProps>> = ({
	children,
	condition = true
}) =>
	<When condition={ condition }>
		<Row
			className='sonar-record-row'
			gutter={ Number(css.size8) }
			justify='space-between'
			wrap={ false }>
			{ children }
		</Row>
	</When>;
